import { render } from "./Verify2FA.vue?vue&type=template&id=07167cea&scoped=true"
import script from "./Verify2FA.vue?vue&type=script&lang=js"
export * from "./Verify2FA.vue?vue&type=script&lang=js"

import "./Verify2FA.vue?vue&type=style&index=0&id=07167cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07167cea"]])

export default __exports__